if (!customElements.get('product-specs')) {
  class ProductSpecs extends HTMLElement {
    connectedCallback() {
      this.contentEl = this.querySelector('.specs-content');

      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data.variant) return;
        this.renderVariant(data.variant.id);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    renderVariant(variantId) {
      const url = `${this.dataset.productUrl}?section_id=${this.dataset.section}&variant=${variantId}`;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newContent = doc.getElementById(this.dataset.contentId);
          if (newContent && this.contentEl) {
            this.contentEl.innerHTML = newContent.innerHTML;
          }
        });
    }
  }

  customElements.define('product-specs', ProductSpecs);
}
